const types = {
    CREATE_MUNICIPALITY: 'municipality/createMunicipality',
    FETCH_MUNICIPALITIES_LIST: 'municipality/fetchMunicipalitiesList',
    SET_MUNICIPALITIES_LIST: 'municipality/setMunicipalitiesList',
    FETCH_MUNICIPALITY: 'municipality/fetchMunicipality',
    SET_MUNICIPALITY: 'municipality/setMunicipality',
    SET_MUNICIPALITY_SILENT: 'municipality/setMunicipalitySilent',
    UNSET_MUNICIPALITY: 'municipality/unsetMunicipality',
    UPDATE_MUNICIPALITY: 'municipality/updateMunicipality',
    MUNICIPALITY_API_ERROR: 'municipality/municipalityAPIError',
    SET_MUNICIPALITY_DATA: 'municipality/setMunicipalityData',
    // organization
    CREATE_ORGANIZATION: 'municipality/createOrganization',
    FETCH_ORGANIZATIONS_LIST: 'municipality/fetchOrganizationsList',
    SET_ORGANIZATIONS_LIST: 'municipality/setOrganizationsList',
    FETCH_ORGANIZATION: 'municipality/fetchOrganization',
    SET_ORGANIZATION: 'municipality/setOrganization',
    UNSET_ORGANIZATION: 'municipality/unsetOrganization',
    UPDATE_ORGANIZATION: 'municipality/updateOrganization',
    ORGANIZATION_API_ERROR: 'municipality/organizationAPIError',
    SET_ORGANIZATION_TREE: 'municipality/setOrganizationTree',
    FETCH_ORGANIZATION_TREE: 'municipality/fetchOrganizationTree',
    ARCHIVE_ORGANIZATION: 'municipality/archiveOrganization',
    // key
    GET_KEY_ORGANIZATION: 'municipality/getKeyOrganization',
    GET_KEY_MUNICIPALITY: 'municipality/getKeyMunicipality',
    CREATE_KEY: 'municipality/createKey',
    // tenant
    GET_TENANT_INFO: 'municipality/getTenantInfo',
    CREATE_TENANT_GROUP: 'municipality/createTenantGroup',
    EDIT_TENANT_GROUP: 'municipality/editTenantGroup',
    DELETE_TENANT_GROUP: 'municipality/deleteTenantGroup',
    DELETE_REMOVED_ENTRA_ID_USERS: 'municipality/deleteRemovedEntraIdUsers',
    LIST_REMOVED_ENTRA_ID_USERS: 'municipality/listRemovedEntraIdUsers',
    CHECK_REMOVED_ENTRA_ID_USERS: 'municipality/checkRemovedEntraIdUsers',
    REMOVED_ENTRA_ID_ERROR: 'municipality/removedEntraIdError',
    IGNORE: 'municipality/ignore'
}

export default types;